<div class="dialog-container">
  <header class="dialog-header">
    <div>
      <h2>Edit Station Rate</h2>
      <p class="station-line">{{ data.station.call_sign }} · {{ data.station.name }}</p>
    </div>
    <button type="button" class="icon-close" (click)="onCancel()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="dialog-body">
    <form class="rate-form" (ngSubmit)="onSubmit()">
      <label class="field">
        <span class="field-label">Package name</span>
        <input class="control" type="text" [(ngModel)]="rateData.friendly_name" name="friendly_name" required />
      </label>

      <label class="field">
        <span class="field-label">Spot length</span>
        <select class="control" [(ngModel)]="rateData.spot_length" name="spot_length" required>
          @for (option of spotLengthOptions; track option.value) {
            <option [ngValue]="option.value">{{ option.label }}</option>
          }
        </select>
      </label>

      <div class="field-row">
        <label class="field">
          <span class="field-label">Start hour</span>
          <select class="control" [(ngModel)]="rateData.start_hour" name="start_hour" required>
            @for (hour of hourOptions; track hour.value) {
              <option [ngValue]="hour.value">{{ hour.label }}</option>
            }
          </select>
        </label>
        <label class="field">
          <span class="field-label">Last hour (inclusive)</span>
          <select class="control" [(ngModel)]="rateData.end_hour" name="end_hour" required>
            @for (hour of endHourOptions; track hour.value) {
              <option [ngValue]="hour.value" [disabled]="rateData.start_hour !== undefined && hour.value < rateData.start_hour">{{ hour.label }}</option>
            }
          </select>
        </label>
      </div>

      <div class="field">
        <span class="field-label">Days of week</span>
        <div class="day-chips">
          <button type="button" class="day-chip" [class.active]="rateData.days!.mon" (click)="rateData.days!.mon = !rateData.days!.mon">Mon</button>
          <button type="button" class="day-chip" [class.active]="rateData.days!.tue" (click)="rateData.days!.tue = !rateData.days!.tue">Tue</button>
          <button type="button" class="day-chip" [class.active]="rateData.days!.wed" (click)="rateData.days!.wed = !rateData.days!.wed">Wed</button>
          <button type="button" class="day-chip" [class.active]="rateData.days!.thu" (click)="rateData.days!.thu = !rateData.days!.thu">Thu</button>
          <button type="button" class="day-chip" [class.active]="rateData.days!.fri" (click)="rateData.days!.fri = !rateData.days!.fri">Fri</button>
          <button type="button" class="day-chip" [class.active]="rateData.days!.sat" (click)="rateData.days!.sat = !rateData.days!.sat">Sat</button>
          <button type="button" class="day-chip" [class.active]="rateData.days!.sun" (click)="rateData.days!.sun = !rateData.days!.sun">Sun</button>
        </div>
      </div>

      <div class="field">
        <span class="field-label">Pricing</span>
        <div class="pricing-toggle">
          <button type="button" class="pricing-option" [class.active]="pricingType === 'cpm'" (click)="setPricingType('cpm')">CPM</button>
          <button type="button" class="pricing-option" [class.active]="pricingType === 'ratecard'" (click)="setPricingType('ratecard')">Rate card</button>
        </div>
      </div>

      @if (pricingType === 'cpm') {
        <label class="field">
          <span class="field-label">CPM</span>
          <div class="money-control">
            <span class="money-prefix">$</span>
            <input class="control money-input" type="number" [(ngModel)]="rateData.cpm" name="cpm" min="0" step="0.01" required />
          </div>
          <span class="field-hint">Cost per 1,000 impressions</span>
        </label>
      } @else {
        <label class="field">
          <span class="field-label">Rate card price</span>
          <div class="money-control">
            <span class="money-prefix">$</span>
            <input class="control money-input" type="number" [(ngModel)]="rateData.ratecard" name="ratecard" min="0" step="0.01" required />
          </div>
          <span class="field-hint">Fixed rate card price</span>
        </label>
      }
    </form>
  </div>

  <footer class="dialog-footer">
    <button type="button" class="btn-cancel" (click)="onCancel()" [disabled]="loading">Cancel</button>
    <button type="button" class="btn-submit" (click)="onSubmit()" [disabled]="loading || !isFormValid()">
      @if (loading) {
        <mat-spinner diameter="18"></mat-spinner>
        <span>Updating…</span>
      } @else {
        <span>Update Rate</span>
      }
    </button>
  </footer>
</div>
